<template>
    <div class="search_nav">
        <el-button type="primary" @click="showAdd()">新建</el-button>
        <el-button type="primary" @click="">刷新</el-button>
    </div>
    <el-table :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}" style="width: 100%;">
      <el-table-column label="生产商ID" width="100">
        <template #default="scope">
          <div>
            <span>{{ scope.row.id }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="生产商简称" width="180">
        <template #default="scope">
          <div>
            <span>{{scope.row.auth_name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="生产商全称" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="组织机构代码" width="180">
        <template #default="scope">
          <div>
            <span>{{scope.row.code}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
        <template #default="scope">
          <div>
            <span>{{ scope.row.createTime }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 对话框--新建 -->
    <el-dialog v-model="dialogFormVisible" title="新建栏目" width="500" :close-on-click-modal="false">
        <el-form :model="addInfo" label-position="right" label-width="auto">
        <el-form-item label="栏目名称">
            <el-input v-model="addInfo.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="类型">
            <el-select v-model="addInfo.type" placeholder="请选择类型">
            <el-option label="菜单" value="MENU" />
            <el-option label="按钮" value="BUTTON" />
            <el-option label="API" value="API" />
            </el-select>
        </el-form-item>
        <el-form-item label="权限标识">
            <el-input v-model="addInfo.code" autocomplete="off" />
        </el-form-item>
        <el-form-item label="菜单图标">
            <el-input v-model="addInfo.icon" autocomplete="off" />
        </el-form-item>
        <el-form-item label="所属菜单">
            <el-select v-model="addInfo.parentId" placeholder="请选择所属菜单">
            <el-option v-for="(item,index) in firstMenu" :label="item.name" :value="item.id" />
            <el-option label="无" value="0" />
            </el-select>
        </el-form-item>
        <el-form-item label="资源路径">
            <el-input v-model="addInfo.resource" autocomplete="off" />
        </el-form-item>
        <el-form-item label="排序">
            <el-input v-model="addInfo.seq" autocomplete="off" />
        </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="save()">保存</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--删除 -->
    <el-dialog
      v-model="centerDialogVisible"
      title="提示"
      width="500"
      align-center
    >
      <span>确定删除该权限栏目？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteRole()">确定</el-button>
        </div>
      </template>
    </el-dialog>

  </template>
  
  <script>

  export default {
  name:'Finance',
  data() {
    return {
        centerDialogVisible:false,
        currt_id:'', //当前操作id
        is_update:0, //编辑/新增
        dialogFormVisible:false,
        firstMenu:[],
        tableData:[
             {
                "id": '01',
                "auth_name": "捷顺科技",
                "name": "深圳捷顺科技有限公司",
                "code":'12345678X',
                "createTime": '2024-02-26'
              },
              {
                "id": '02',
                "auth_name": "珠海泰坦",
                "name": "珠海泰坦科技股份有限公司",
                "code":'61823727X',
                "createTime": '2024-02-26'
              }
        ],
        addInfo:{
            name: '',
            type: '',
            code: '',
            icon: '',
            resource: '',
            seq: '',
            parentId: '',
        }  
    }
  },
  computed: {
    filteredMessage() {
      // 这里可以实现类似过滤器的转换逻辑
    }
  },
  beforeCreate(){
    
  },
  created(){
    
  },
  mounted(){
    
  },
  methods:{
    showAdd(){
        this.is_update = 0;
        this.addInfo = Object.fromEntries(
          Object.keys(this.addInfo).map(key => [key, ''])
        );
        this.dialogFormVisible = true;
    },
    handleEdit(index,row){
      let that = this;
      that.is_update = 1;
      that.dialogFormVisible = true;
    },
    handleDelete(index,row){
        this.centerDialogVisible = true;
        this.currt_id = row.id;
    },
    typeFilter(value) {
      //过滤函数
      if(value=='MENU'){
        return '菜单'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
</style>